<h1>{{'CONSENT_PREVIEW.ASK_FOR_CONSENT' | translate}}</h1>
<tr *ngFor="let scope of scopes">
    <td>{{scope}}</td>
</tr>
<div *cidContentLoader="contentLoading">
    <div>
        <ul *ngIf="claimsConsent == true">
            <li *ngFor="let claims of consentClaims" style="list-style: none; width: 100%;">
                <div style="display: inline-flex" *ngIf="claims.name != constants?.ADDRESS">
                    <input #check type="checkbox" [checked]="claims.status == false" [disabled]="claims.status == false" (change)="changeSelection(claims.claims,check.checked)">
                    <p style="padding:0 10px; margin: 0;">{{claims.name}} -- {{claim_values[claims.claims]}}</p>
                </div>
                <!--
                  fix:[1350](https://gitlab.widas.de/cidaas-v2/framework/issues/-/issues/1350)
                  Added null check for the claimsAddress
                 -->
                <div style="display: inline-flex" *ngIf="claims.name === constants?.ADDRESS && claimsAddress">
                    <input #check type="checkbox" [checked]="claims.status == false" [disabled]="claims.status == false" (change)="changeSelection(claims.claims,check.checked)">
                    <p style="padding:0 10px; margin: 0;">{{claims.name}} -- {{claimsAddress['street_address']}} {{claimsAddress['formatted']}} {{claimsAddress['area']}} {{claimsAddress['city']}} {{claimsAddress['region']}} {{claimsAddress['postal_code']}}</p>
                </div>
            </li>
        </ul>
        <mat-accordion class="consent_scope" *ngIf="scopesConsent == true">
            <ul style="list-style: none; padding: 0;">
                <li *ngFor="let scope of scopesConsents; let i = index" style="display: inline-flex;width: 100%;">
                    <mat-expansion-panel [expanded]="step === i" (opened)="_showFields(i)" hideToggle>
                        <mat-expansion-panel-header>
                          <mat-panel-description>
                            <span>
                              <span class="icon"></span>
                              <span class="scope_description"><b>{{scope?.scope}}</b></span>
                            </span>
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <mat-action-row>
                            {{scope?.description}}
                        </mat-action-row>
                      </mat-expansion-panel>
                      <div style="padding:20px 5px;">
                        <input class="checkbox-new" #checkbox type="checkbox" [checked]="scope.status == false" (change)="scopeSelection(scope.scope, checkbox.checked)">
                    </div>
                </li>
            </ul>
        </mat-accordion>

    </div>
</div>
<div class="mat-error">
    {{errorMessage | translate}}
</div>
<div class="section btn-group">
    <a (click)="commonFunc.getRedirectedByRequestId()">{{'CANCEL' | translate}}</a>
    <app-button (clickEvent)="acceptScopeConsent()" [btnOption]="buttonOptions.accept" [loading]="submissionInProgress">
    </app-button>
</div>
